import t from 'src/helpers/Languages.js'
import {popupStyle} from 'src/components/UI/overlays/styles.js'
import type {PopupBooleanOptions} from 'src/components/UI/overlays/Popup.js'

// The labels (Ja and Nee, unless given) and width of a question in the courier app, for popup.openBoolean
export default function questionOptions(labels: Pick<PopupBooleanOptions, 'confirmLabel' | 'cancelLabel'> = {}): PopupBooleanOptions {
    return {confirmLabel: t('yes'), cancelLabel: t('no'), width: popupStyle.width.question, ...labels}
}
